<template>
  <Base :is-loading="dataIsLoad" :base-id="'lb-refund'">
    <template #header>
      <h4 v-if="step === 1" class="modal-title">
        <p class="refund-title-ch mb-3">選擇退貨商品</p>
      </h4>
      <h4 v-else-if="step === 2" class="modal-title">
        <p class="refund-title-ch mb-3">選擇退貨原因</p>
      </h4>
      <h4 v-else class="modal-title">
        <p class="refund-title-ch">我要退貨</p>
        <p class="refund-title-en">Return</p>
      </h4>
      <a href="#" class="modal-close" @click.prevent="closeModal">
        <i class="icon-popup-close" />
      </a>
    </template>
    <template #body>
      <form id="form-return-products" ref="refundForm" action="/User/Order/Refund" method="POST">
        <div v-show="step === 0" class="remind-text">
          <p>1.未滿免運門檻，需支付原訂單出貨運費(宅配120元/超商80元)</p>
          <p>2.未達滿額贈門檻，需支付贈品原價金額</p>
          <p>3.未達組合優惠門檻，將恢復原價計算</p>
          <p v-if="data.UseFaPoints > 0">4.未達fa points折抵門檻，需支付原本折抵金額</p>
          <p>
            <span v-if="data.UseFaPoints > 0">5</span>
            <span v-else>4</span>
            <span>.未達加價購門檻，加購商品將會以原價計算</span>
          </p>
        </div>
        <div v-show="step === 1">
          <input name="TransactionID" type="hidden" :value="modalData" />
          <input name="IsCreditCard" type="hidden" :value="data.IsCreditCard" />
          <div
            v-for="(market, index) in data.Markets"
            :key="market.ID"
            :ref="'refund' + index"
            class="row refund-product-row refund-border-bottom"
            :index="index"
            :class="{ last: data.Markets.length === 1 }"
          >
            <img class="img-fluid refund-product-pic" :src="market.Cover" :alt="market.Name" />
            <div class="step1-left">
              <div class="refund-text-s1-block">
                <a class="refund-product-title" :href="market.Url">
                  {{ market.Name }}
                </a>
                <p class="refund-product-sellprice">規格 : {{ market.Size }}</p>
                <p class="refund-product-sellprice">單價 : NT$ {{ market.SellPrice }}</p>
                <p class="refund-product-subtotal">小計 : NT$ {{ market.SubTotal }}</p>
              </div>
              <div class="refund-block checkbox-btn-block">
                <div :ref="'block' + index" class="refund-num-s1-block">
                  <div
                    v-if="market.Events.length !== 0 && !market.Events[0].CanScatteredRefund"
                    class="refund-count-select"
                  >
                    <div class="unselect-txt">{{ market.Count }}</div>
                    <input
                      v-if="market.checked"
                      class="refund-market-val"
                      type="hidden"
                      name="RefundMarket"
                      :value="market.ID + '_' + market.Count"
                    />
                  </div>
                  <div v-else class="refund-count-select">
                    <div :id="'selectRef' + index" :ref="'selectRef' + index" class="select-txt">
                      <a
                        class="select-result"
                        href="javascript:;"
                        @click="toggleOption(index, $event)"
                      >
                        <span>{{ market.refundCount }}</span>
                        <input
                          v-if="market.checked"
                          class="refund-market-val"
                          type="hidden"
                          name="RefundMarket"
                          :value="market.ID + '_' + market.refundCount"
                        />
                      </a>
                      <ul v-if="market.openSelect" class="select-options">
                        <li
                          v-for="(item, indexInCount) in market.countOptions"
                          :key="item.value + indexInCount"
                          :class="{ selected: item.value === 0 }"
                          @click="changeValue(item.value, index)"
                        >
                          <a href="javascript:;">{{ item.text }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="checkbox-btn-style">
                  <input
                    :id="'check-' + market.ID"
                    :class="{ disabled: isCheckGift }"
                    :checked="market.checked"
                    type="checkbox"
                    name="RefundMarketCheck"
                    :value="market.ID"
                    @click="toggleChecked(market)"
                  />
                  <div>
                    <span class="product-unchecked-text">選擇商品</span>
                    <span class="product-checked-text">已選擇</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="step === 2">
          <div class="row refund-product-row refund-border-bottom">
            <img
              class="img-fluid refund-product-pic"
              :src="selectedItemDetail.Cover"
              :alt="selectedItemDetail.Name"
            />
            <div class="step1-left">
              <div class="refund-text-s1-block">
                <a class="refund-product-title" :href="selectedItemDetail.Url">
                  {{ selectedItemDetail.Name }}
                </a>
                <p class="refund-product-sellprice">規格 : {{ selectedItemDetail.Size }}</p>
                <p class="refund-product-sellprice">
                  單價 : NT$ {{ selectedItemDetail.SellPrice }}
                </p>
                <p class="refund-product-subtoatal">小計 : NT$ {{ selectedItemDetail.SubTotal }}</p>
              </div>
              <div class="refund-text-s1-block">
                <p>
                  數量 :
                  {{
                    selectedItemDetail.refundCount < 10
                      ? '0' + selectedItemDetail.refundCount
                      : selectedItemDetail.refundCount
                  }}
                </p>
              </div>
            </div>
          </div>
          <div v-for="item in selectedItem" :key="item.OrderMarketID">
            <div
              v-show="item.OrderMarketID === selectedItemDetail.ID"
              class="row refund-product-row"
            >
              <input name="reason" type="hidden" :value="getSelectedItemReason(item)" />
              <div
                v-for="(category, categoryIndex) in reasonCheck"
                :key="category.code + categoryIndex"
                class="refund-title-category-block row col-12"
              >
                <div
                  class="refund-check-reason-block col-12 custom-ui category"
                  :class="{ open: category.check }"
                >
                  <input
                    disabled
                    :id="'check-reason-category-' + category.code"
                    class="input-check-refund checkbox"
                    :checked="category.check"
                    :value="category.text"
                    type="checkbox"
                    @click="toggleReasonCategory(category.code)"
                  />
                  <label class="refund-checkbox" :for="'check-reason-category-' + category.code">
                    <div>{{ category.text }}</div>
                  </label>
                </div>
                <div v-if="category.check && category.code !== 'b'">
                  <p
                    v-if="
                      category.check &&
                      category.sub.filter((element) => element.check === true).length === 0
                    "
                    class="refund-category-remind-text"
                  >
                    *請勾選至少一個小項
                  </p>
                </div>
                <div v-else-if="category.check && category.code === 'b'">
                  <p
                    v-if="category.sub.filter((element) => element.check === true).length === 0"
                    class="refund-category-remind-text"
                  >
                    *請勾選至少一個小項
                  </p>
                  <p v-else class="refund-category-remind-text">*限勾選兩個小項</p>
                </div>
                <div v-if="category.check" class="row col-12 refund-title-subcategory-block">
                  <div
                    v-for="(subCategory, subCategoryIndex) in category.sub"
                    :key="subCategory.code + subCategoryIndex"
                    class="col-sm-6 col-12 refund-reason-subcategory-block"
                  >
                    <div class="refund-check-reason-block custom-ui subcategory">
                      <input
                        :id="'check-reason-subcategory-' + category.code + subCategory.code"
                        class="input-check-refund checkbox"
                        :disabled="category.code === 'b' && !subCategory.check && upToTwoSub"
                        :checked="subCategory.check"
                        :value="subCategory.text"
                        type="checkbox"
                        @click="toggleReasonSubCategory(categoryIndex, subCategoryIndex)"
                      />
                      <label
                        class="refund-checkbox"
                        :for="'check-reason-subcategory-' + category.code + subCategory.code"
                      >
                        <div>{{ subCategory.text }}</div>
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  v-if="category.check && category.code === 'b'"
                  class="refund-reason-other-block"
                >
                  <p class="remind-check-txt" style="padding-left: 24px; margin-bottom: 5px">
                    必填
                  </p>
                  <textarea
                    v-model="selectedItemType2Reason[fillReasonIndex]"
                    class="refund-other-input"
                    placeholder="請詳述商品退貨原因，如：口袋破洞、領口有污漬...等"
                    onkeydown="if(event.keyCode == 13) return false;"
                  />
                  <div v-if="type2ReasonOverMax" class="error">字數上限為48 字元</div>
                </div>
              </div>
              <div class="refund-reason-category-block">
                <div class="refund-reason-other-block">
                  <p>其他<span class="remind-check-txt">(選填)</span></p>
                </div>
              </div>
              <div class="refund-reason-other-block">
                <textarea
                  v-model="selectedItemOtherReason[fillReasonIndex]"
                  class="refund-other-input"
                  onkeydown="if(event.keyCode == 13) return false;"
                />
                <div v-if="type5ReasonOverMax" class="error">字數上限為48 字元</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isCheckGift && step > 2" class="check-gift-block">
          <div v-if="giftData.length > 0" class="py-2 text-danger">
            提醒您：退貨商品須將活動贈品寄回
          </div>
          <table class="table table-bordered row-product">
            <tr v-for="gift in giftData" :key="gift.OrderMarketID" class="tr-title">
              <td class="text-left font-weight-bold d-flex align-items-center" colspan="3">
                <div class="float-left custom-ui">
                  <input
                    :id="'check-' + gift.OrderMarketID"
                    class="input-check-refund checkbox"
                    type="checkbox"
                    name="RefundMarketCheck"
                    :value="gift.OrderMarketID"
                    style="cursor: not-allowed; pointer-events: none"
                    checked="true"
                  />
                  <label for="'check-' + gift.OrderMarketID" style="cursor: not-allowed" />
                </div>
                <div class="float-left">
                  <div>{{ gift.Name }}-{{ gift.ColorName }}-{{ gift.Size }}</div>
                  <input
                    type="hidden"
                    name="RefundMarket"
                    :value="gift.OrderMarketID + '_' + gift.Count"
                  />
                  <div>
                    <span class="text-gray-800 mb-2">{{ gift.GiftEvent.Name }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </form>
    </template>
    <template #footer>
      <div class="col">
        <div v-if="isCheckGift && step > 2" class="refund-btn-block pt-0">
          <a
            href="#"
            class="btn-refund-action btn btn-outline-secondary"
            @click.prevent="loopStep2(-1)"
          >
            上一步
          </a>
          <input
            class="btn-refund-action btn btn-fill-primary"
            type="submit"
            value="確認退貨"
            @click.prevent="submitFn()"
          />
        </div>
        <div v-if="step === 0" class="refund-btn-block pt-0">
          <a href="#" class="btn-refund-action btn btn-fill-primary" @click.prevent="closeModal">
            取消
          </a>
          <a href="#" class="btn-refund-action btn btn-fill-primary" @click.prevent="step++">
            下一步
          </a>
        </div>
        <div v-if="step === 1" class="refund-btn-block pt-0">
          <a href="#" class="btn-refund-action btn btn-outline-secondary" @click.prevent="step--">
            上一步
          </a>
          <a
            href="#"
            :class="{ disabled: selectedItem.length === 0 }"
            class="btn-refund-action btn btn-fill-primary"
            @click.prevent="goStep2"
          >
            下一步
          </a>
        </div>
        <div v-if="step === 2" class="refund-btn-block pt-0">
          <a
            href="#"
            class="btn-refund-action btn btn-outline-secondary"
            @click.prevent="loopStep2(-1)"
          >
            上一步
          </a>
          <a
            v-if="showNextStep"
            href="#"
            class="btn-refund-action btn btn-fill-primary"
            :class="{ disabled: !canMoveNextItem }"
            @click.prevent="loopStep2(1)"
          >
            下一步
          </a>
          <a
            v-else
            href="#"
            class="btn-refund-action btn btn-fill-primary"
            :class="{ disabled: !canMoveNextItem }"
            @click.prevent="getReservedMarkets(modalData)"
          >
            確認退貨
          </a>
        </div>
      </div>
    </template>
  </Base>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import Base from '@global/components/common/modal/Base.vue';
import useAlert from '@global/composable/useAlert';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';

const modalStore = useModalStore();
const { closeModal } = modalStore;
const { modalData } = storeToRefs(modalStore);

const { alertDialog } = useAlert();
const { getOrderAPI, postRefundCalculateAPI } = useAxiosAPI();
// 餐飲的退貨跟別人不一樣
const reasonCheck = ref([
  {
    code: 'c',
    check: false,
    text: '商品內容物問題',
    sub: [
      { code: '1', check: false, text: '商品缺件' },
      { code: '2', check: false, text: '寄錯商品' },
      { code: '3', check: false, text: '買錯商品' },
    ],
  },
]);

const step = ref(0);
const data = ref([]);
const selectedItem = ref([]);
const selectedItemReason = ref([]);
const selectedItemType2Reason = ref([]);
const selectedItemOtherReason = ref([]);
const dataIsLoad = ref(false);
const isCheckGift = ref(false);
const giftData = ref([]);
const reservedMarkets = ref([]);
const reservedUnMatchAddons = ref([]);
const fillReasonIndex = ref(0);
const selectedItemDetail = ref({});

const refundForm = ref(null);

const type2ReasonOverMax = computed(() => {
  // 當有選到第二大項的原因
  if (data.value && Object.keys(selectedItemDetail.value).length !== 0) {
    return selectedItemType2Reason.value[fillReasonIndex.value].length > 48;
  }
  return false;
});

const type5ReasonOverMax = computed(() => {
  // 要判斷五(其他)是否輸入超過48個字元
  if (data.value && Object.keys(selectedItemDetail.value).length !== 0) {
    return selectedItemOtherReason.value[fillReasonIndex.value].length > 48;
  }
  return false;
});

const showNextStep = computed(() => {
  const selectItemIndex = selectedItem.value.findIndex(
    (item) => item.OrderMarketID === selectedItemDetail.value.ID,
  );
  // 最後一項商品
  if (selectedItem.value.length === selectItemIndex + 1) {
    return false;
  }
  return true;
});

const canMoveNextItem = computed(() => {
  let result = true;
  const reg = /^b+/gm;

  if (selectedItemDetail.value.reasonSelect.length === 0 || type5ReasonOverMax.value) {
    result = false;
    return result;
  }

  // 有勾選主項目但副項目沒勾選的狀況下，不通過
  reasonCheck.value.forEach((category) => {
    if (category.check) {
      if (category.sub.filter((sub) => sub.check).length === 0) {
        result = false;
      }
    }
  });

  selectedItemDetail.value.reasonSelect.forEach((category) => {
    if (reg.test(category)) {
      // 有勾選第二類大項就必須填寫原因
      if (selectedItemType2Reason.value[fillReasonIndex.value].length === 0) {
        result = false;
      }

      // 有勾選第二類大項，字數就不能大於48
      if (type2ReasonOverMax.value) {
        result = false;
      }
    }
  });

  return result;
});

const upToTwoSub = computed(() => {
  return reasonCheck.value.find((e) => e.code === 'b').sub.filter((e) => e.check).length === 2;
});

function fetchAPI() {
  getOrderAPI({
    params: {
      OnlyRefundData: 1,
      TransactionID: modalData.value,
    },
  })
    .then((res) => {
      if (res.data.Code === 200) {
        data.value = res.data.Response;
        selectedItemReason.value.length = data.value.Markets.length;
        selectedItemOtherReason.value.length = data.value.Markets.length;
        selectedItemType2Reason.value.length = data.value.Markets.length;
        data.value.Markets.forEach((el, index) => {
          el.openSelect = false;
          el.refundCount = 1;
          el.checked = false;
          el.reasonSelect = [];

          // 正常商品才會有行銷活動，加價購不會有
          // 行銷活動退貨邏輯CanScatteredRefund是false就必須一起退
          if (el.Events.length && el.Events[0].CanScatteredRefund === false) {
            el.selectCount = el.Count;
          } else if (el.Type === 3) {
            // 加價購退貨必須全退
            el.selectCount = el.Count;
          } else {
            el.selectCount = `${el.ID}_1`;
          }

          // 商品數量
          const countOptions = [];

          for (let i = 1; i < el.Count + 1; i++) {
            countOptions.push({
              value: i,
              text: i.toString(),
            });
          }

          el.countOptions = countOptions;

          // 給予每一項商品預設空字串理由
          selectedItemReason.value[index] = '';
          selectedItemOtherReason.value[index] = '';
          selectedItemType2Reason.value[index] = '';
        });
        dataIsLoad.value = true;
      } else {
        closeModal();
      }
    })
    .catch((error) => {
      console.log(error);
      closeModal();
    });
}

function toggleOption(index) {
  data.value.Markets[index].openSelect = !data.value.Markets[index].openSelect;
}

function changeValue(newValue, index) {
  data.value.Markets[index].openSelect = false;
  data.value.Markets[index].refundCount = newValue;
}

function onMinus(index) {
  if (data.value.Markets[index].refundCount > 1) {
    data.value.Markets[index].refundCount -= 1;
  }
}

function onPlus(index) {
  if (data.value.Markets[index].refundCount < data.value.Markets[index].Count) {
    data.value.Markets[index].refundCount += 1;
  }
}

/**
 * @description 清空退貨原因的多選框
 */
function clearReasonCheckbox() {
  reasonCheck.value.forEach((category) => {
    category.check = true;
    category.sub.forEach((sub) => {
      sub.check = false;
    });
  });
}

function setReasonCheckbox() {
  clearReasonCheckbox();

  if (selectedItemDetail.value.reasonSelect.length === 0) return;

  selectedItemDetail.value.reasonSelect.forEach((code) => {
    reasonCheck.value.forEach((category) => {
      if (category.code === code.substring(0, 1)) {
        category.check = true;
        category.sub.forEach((sub) => {
          if (sub.code === code.substring(1)) {
            sub.check = true;
          }
        });
      }
    });
  });
}

/**
 * @description 勾選退貨商品
 * @param {Object} item 退貨商品
 */
function toggleChecked(item) {
  item.checked = !item.checked;
  getSelectedItem();
}

/**
 * @description 大項目種類 code
 * @param {String} categoryCode
 */
function toggleReasonCategory(categoryCode) {
  reasonCheck.value.forEach((ele) => {
    if (ele.code === categoryCode) {
      ele.check = !ele.check;
      // 大項目種類取消後小項目也必需取消

      if (ele.check === false) {
        ele.sub.forEach((subCode) => {
          subCode.check = false;
          const reasonCodeIndex = selectedItemDetail.value.reasonSelect.indexOf(
            ele.code + subCode.code,
          );
          if (reasonCodeIndex !== -1) {
            selectedItemDetail.value.reasonSelect.splice(reasonCodeIndex, 1);
          }
        });
        if (ele.code === 'b') {
          selectedItemType2Reason.value[fillReasonIndex.value] = '';
        }
      }
    }
  });
}

/**
 * @description 紀錄子項目勾選狀態
 * @param {number} categoryIndex
 * @param {number} subCategoryIndex
 */
function toggleReasonSubCategory(categoryIndex, subCategoryIndex) {
  reasonCheck.value[categoryIndex].sub[subCategoryIndex].check =
    !reasonCheck.value[categoryIndex].sub[subCategoryIndex].check;

  const reasonCode =
    reasonCheck.value[categoryIndex].code +
    reasonCheck.value[categoryIndex].sub[subCategoryIndex].code;

  const findIndex = data.value.Markets.findIndex(
    (element) => element.ID === selectedItemDetail.value.ID,
  );

  const reasonCodeIndex = selectedItemDetail.value.reasonSelect.indexOf(reasonCode);
  if (
    selectedItemReason.value[findIndex].length !== 0 &&
    selectedItemReason.value[findIndex].at(-1) !== ','
  ) {
    selectedItemReason.value[findIndex] += ',';
  }
  if (reasonCodeIndex === -1) {
    selectedItemDetail.value.reasonSelect.push(reasonCode);
  } else {
    selectedItemDetail.value.reasonSelect.splice(reasonCodeIndex, 1);
  }
}

/**
 * @description 取得勾選的退貨商品
 */
function getSelectedItem() {
  selectedItem.value = [];
  data.value.Markets.forEach((element) => {
    if (element.checked) {
      selectedItem.value.push({
        OrderMarketID: element.ID,
        Count: element.refundCount.toString(),
      });
    }
  });
}

/**
 * @description 前往勾選退貨原因
 */
function goStep2() {
  step.value = 2;

  selectedItemDetail.value = data.value.Markets.find(
    (element) => element.ID == selectedItem.value['0'].OrderMarketID,
  );

  // mapping selectedItemReason array index
  fillReasonIndex.value = data.value.Markets.findIndex(
    (element) => element.ID === selectedItemDetail.value.ID,
  );

  setReasonCheckbox();
}

/**
 * @description 勾選多個退貨商品時
 * @param {Number} dir 上一個/下一個退貨商品
 */
function loopStep2(dir) {
  let selectItemIndex = selectedItem.value.findIndex(
    (item) => item.OrderMarketID === selectedItemDetail.value.ID,
  );
  // 下一個退貨商品
  if (dir === 1) {
    selectItemIndex += 1;
  }

  // 上一個退貨商品
  if (dir === -1) {
    // 當只有選一個商品退貨時，或有多項商品退貨但不是從列表中第一項商品退時
    if (selectItemIndex === 0 && step.value !== 3) {
      step.value = 1;
      clearReasonCheckbox();
      return;
    }

    // 贈品畫面時
    if (step.value === 3) {
      step.value = 2;
    } else {
      // 返回上一個退貨商品
      selectItemIndex -= 1;
    }
    selectedItemReason.value[selectItemIndex] = '';
  }

  // 上一個 or 下一個的商品 detail
  selectedItemDetail.value = data.value.Markets.find(
    (element) => element.ID === selectedItem.value[selectItemIndex].OrderMarketID,
  );

  fillReasonIndex.value = data.value.Markets.findIndex(
    (element) => element.ID === selectedItemDetail.value.ID,
  );

  setReasonCheckbox();
}

/**
 * @description 寫入勾選框及輸入框內容
 * @param {Number} index
 */
function setOtherReason() {
  selectedItem.value.forEach((item) => {
    const refundItem = data.value.Markets.find((e) => e.ID === item.OrderMarketID);
    const refundItemIndex = data.value.Markets.findIndex((e) => e.ID === item.OrderMarketID);
    refundItem.reasonSelect.forEach((select) => {
      const categoryCode = select.substring(0, 1);
      const subCode = select.substring(1);
      const categoryObj = reasonCheck.value.find((e) => e.code === categoryCode);
      const subObj = categoryObj.sub.find((e) => e.code === subCode);
      selectedItemReason.value[refundItemIndex] +=
        categoryObj.text.substring(0, categoryObj.text.indexOf('、')) + '_' + subObj.text + ',';
    });
    // 寫入五、其他(選填)
    if (selectedItemOtherReason.value[refundItemIndex].length !== 0) {
      selectedItemReason.value[refundItemIndex] +=
        '五_' + selectedItemOtherReason.value[refundItemIndex].replace(/,/g, '，') + ',';
    }
    // 寫入二的備註說明
    const string2Array = selectedItemReason.value[refundItemIndex].split(',');
    if (selectedItemType2Reason.value[refundItemIndex].length !== 0) {
      string2Array.splice(
        string2Array.findLastIndex((e) => e.includes('二')) + 1,
        0,
        '二_' + selectedItemType2Reason.value[refundItemIndex].replace(/,/g, '，'),
      );
    }
    selectedItemReason.value[refundItemIndex] = string2Array.toString();
  });
}

/**
 * @description 返回第一步
 */
function returnStep1() {
  step.value = 1;
  clearReasonCheckbox();
}

/**
 * @description 退貨試算
 */
async function getReservedMarkets(orderID) {
  getSelectedItem();
  setOtherReason();

  selectedItemReason.value.forEach((itemReason, index) => {
    if (itemReason.substr(-1) === ',') {
      selectedItemReason.value[index] = itemReason.slice(0, -1);
    }
  });

  postRefundCalculateAPI({
    TransactionID: orderID,
    RefundMarkets: selectedItem.value,
  })
    .then((res) => {
      if (res.data.Code === 200) {
        reservedMarkets.value = res.data.Response.ReservedMarkets;
        checkRemainItemIfMatchAddon();
      } else {
        closeModal();
      }
    })
    .catch((error) => {
      console.log(error);
      closeModal();
    });
}

/**
 * @description 檢查剩下商品是否有加價購且是否符合條件, 若無跳警告視窗提醒
 */
function checkRemainItemIfMatchAddon() {
  reservedUnMatchAddons.value = [];
  if (reservedMarkets.value.length) {
    reservedMarkets.value.forEach((remainItem) => {
      if (remainItem.Type === 3 && !remainItem.AddOnEvent.IsMatch) {
        reservedUnMatchAddons.value.push(remainItem);
      }
    });
  }

  if (reservedUnMatchAddons.value.length > 0) {
    let reservedText = '';
    reservedUnMatchAddons.value.forEach((ele, index) => {
      reservedText += `<p class="mb-1">${index + 1}. ${ele.Name}(${ele.ColorName}${
        ele.Size
      })將以NT$${ele.SellPrice.toLocaleString()}計算</p>`;
    });

    alertDialog.special(
      `
        <div class="text-left">
          提醒您:<br />您選擇的退貨商品無達到加價購活動門檻<br />
          <span class="text-danger h5">請您勾選是否要將加價購商品一併退回</span><br />
          若無退回 加價商品將會以商品原價計算 :
        </div>
        <div class="text-left text-danger my-4">${reservedText}</div>
        <div class="row">
          <div class="col">
            <a
              id=""
              class="btn-confirm-alert btn btn-outline-secondary btn-block"
              href="#"
              >不退回，繼續下一步</a
            >
          </div>
          <div class="col">
            <a id="" class="btn-cancel-alert btn btn-secondary btn-block" href="#"
              >我要退回</a
            >
          </div>
        </div>
      `,
      () => {
        checkRefundGift(reservedMarkets.value);
      },
    );
  } else {
    checkRefundGift(reservedMarkets.value);
  }
}

/**
 * @description 確認是否有贈品
 * @param {Array} remainItems 退貨商品
 */
function checkRefundGift(remainItems) {
  const giftItems = remainItems.filter((item) => item.Type === 2 && !item.GiftEvent.IsMatch);
  isCheckGift.value = true;
  giftData.value = giftItems;
  if (giftData.value.length === 0) {
    refundForm.value.submit();
  } else {
    step.value = 3;
  }
}

/**
 * @description 取得商品退貨理由
 * @param {Object} item 退貨商品
 */
function getSelectedItemReason(item) {
  const findIndex = data.value.Markets.findIndex((element) => element.ID === item.OrderMarketID);

  return selectedItemReason.value[findIndex];
}

function submitFn() {
  refundForm.value.submit();
}

onMounted(() => {
  fetchAPI();
});
</script>
